import { useField } from "formik";
import { ParameterTypeInput } from "./ParameterTypeInput";
import { ParameterTypeSelector } from "./ParameterTypeSelector";
import {
  InputNumberFloat,
  InputNumberMinMax,
  InputRandom,
  InputText,
} from "@components-common/forms";
import { Col, Form } from "taltech-styleguide";

export const ParameterTypeRandom = ({
  type,
  id = "value",
  ...rest
}: any = {}) => {
  //   const [field, meta, helpers] = useField("type");
  const [field] = useField(`creationType`);
  const [fieldType] = useField(`type`);
  return (
    <Form.Group>
      <div className="d-flex">
        <Col xs="5">
          <ParameterTypeSelector
            showLabel={true}
            label="Parameter Type"
            showHelp={false}
            elementClass="required"
            id="type"
          />
        </Col>
        <Col
          xs="1"
          style={{ marginTop: "1.25rem" }}
          className="d-flex justify-content-center align-items-center"
        >
          {fieldType.value === "NUMBER" && (
            <InputRandom
              name="creationType"
              changeFn={() => {}}
              value={field.value}
            />
          )}
        </Col>
        <Col xs="6">
          {fieldType.value === "NUMBER" && (
            <InputNumberMinMax
              elementClass={"d-flex grow-1"}
              minId={`min`}
              maxId={`max`}
              minElementClass={`col-6 pe-1 required`}
              maxElementClass={`col-6 ps-1 required`}
              disabled={field.value !== "RANDOM"}
              showLabel={true}
            />
          )}
        </Col>
      </div>
      {fieldType.value === "TEXT" ? (
        <InputText id={"value"} label="Default Value" elementClass="required" />
      ) : (
        <InputNumberFloat
          id={"value"}
          label="Default Value"
          disabled={field.value === "RANDOM"}
          elementClass="required"
          maxValue={99999}
        />
      )}
      <ParameterTypeInput type={field.value} id={id} {...rest} />
    </Form.Group>
  );
};
